import React, { useContext, useState, useEffect } from "react"
import { makeStyles } from "@material-ui/styles"
import { Button, NumberSelect, CartContext } from ".."

const useStyles = makeStyles(theme => {
  return {
    root: {
      borderWidth: "1px 0",
      borderStyle: "solid",
      borderColor: theme.palette.black.supportLight,
      display: "flex",
      padding: theme.spacing(3, 0),
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    fieldWrapper: {
      [theme.breakpoints.down("sm")]: {
        width: "auto",
      },
    },
    button: {
      flexGrow: 1,
      zIndex: 2,
      marginLeft: theme.spacing(1),
      whiteSpace: "nowrap",
      padding: theme.spacing(0, 1),
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
        marginTop: theme.spacing(2),
      },
      "&.block-on-mobile": {
        [theme.breakpoints.down("sm")]: {
          display: "block",
        },
      },
    },
  }
})

export default props => {
  const classes = useStyles(props)
  const i18nmessages = require(`../../puraearth/src/messages/index/${props.langKey}`)

  const { addToCart, items } = useContext(CartContext)
  const [isAdded, setIsAdded] = useState(false)
  const [quantity, setQuantity] = useState(1)
  useEffect(() => {
    if (isAdded) {
      setTimeout(() => {
        setIsAdded(false)
      }, 2000)
    }
  }, [isAdded])

  const maxQuantity = 10
  const cartQuantity = items.reduce((cartQuantity, item) => {
    if (item.product_id === props.itemId) {
      return item.quantity
    }
    return cartQuantity
  }, 0)

  const handleClick = async () => {
    let addedQuantity = quantity
    if (addedQuantity + cartQuantity > maxQuantity) {
      addedQuantity = maxQuantity - cartQuantity
    }
    if (Number.isInteger(addedQuantity) && addedQuantity > 0) {
      setIsAdded(true)
      await addToCart(props.itemId, addedQuantity)
    }
  }
  const handleChange = value => {
    setQuantity(parseInt(value, 10))
  }
  if (props.cartType === undefined) {
    return (
      <div className={classes.root}>
        <div className={classes.fieldWrapper}>
          <NumberSelect
            start={1}
            length={maxQuantity}
            horizontal
            value={quantity}
            width={9}
            hideHelperText
            label={i18nmessages.quantity}
            labelVariant={"body1"}
            labelColor={"black"}
            onChange={handleChange}
          />
        </div>

        <Button
          disabled={props.isDisabled || isAdded || cartQuantity >= maxQuantity}
          className={classes.button}
          data-cy="add-cart-button"
          onClick={handleClick}
          color={props.color}
        >
          {props.addedClass}
          {isAdded || cartQuantity >= maxQuantity
            ? i18nmessages.addedToCart
            : i18nmessages.addToCart}
        </Button>
      </div>
    )
  }

  return (
    <Button
      disabled={props.isDisabled || isAdded || cartQuantity >= maxQuantity}
      className={props.addedClass ? props.addedClass + ' ' + classes.button : classes.button}
      data-cy="add-cart-button"
      onClick={handleClick}
      color={props.color}
    >
      {isAdded || cartQuantity >= maxQuantity
        ? i18nmessages.addedToCart
        : i18nmessages.addToCart}
    </Button>
  )
}
